import React from "react";
import Typography from "@material-ui/core/Typography";

export const HowToJoin = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>How to Join</u>
      </Typography>
      <p>You already have!</p>
      <p>
        We have no strict rules in terms of new member applications or time
        commitments. Just sign up for our weekly missions and show up to play!
        If you're new to the game or some of the mods we use, community Officers
        and Regulars are always happy to explain. Best way is to hang out in our
        Discord server and ask questions!
      </p>
      <p>
        Alternatively, we suggest new players show up early to missions and ask
        for help.
      </p>
    </div>
  );
};

export default HowToJoin;
